import { useEffect, useRef, useState } from 'react';
import { CarTaxiFront, ShoppingCart } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { ArrowHeadSvg, CrossSvg, HamburgerSvg, PersonSvg } from '../../assets/svg';
import Logo from '../../assets/images/logo/logo.png';
import LogoCircle from '../../assets/images/logo/logo-circle.png';
import { useAuth } from '../../contexts/AuthContext';
import { useCommonContext } from '../../contexts/CommonContext';
import * as AuthActions from '../../redux/actions/authAction';
import * as CommonActions from '../../redux/actions/commonAction';
import * as EcommerceActions from '../../redux/actions/ecommerceAction';
import ComingSoonModal from './ComingSoonModal';

const MilanSathiHeader = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { sidebarWidth } = useCommonContext();
    const { customerDetails } = useSelector(state => state?.authReducer);
    // console.log("Customer Details :::", customerDetails);

    const { isScreenScroll } = useSelector(state => state?.commonReducer);
    const { productCartData } = useSelector(state => state?.ecommerceReducer);
    const isDashboardRoute = location.pathname.startsWith("/dashboard") || location.pathname.startsWith("/verification") || location.pathname.startsWith("/profile/edit");

    const navRef = useRef(null);
    const [shownav, setShownav] = useState(false);
    const [showComingSoon, setShowComingSoon] = useState(false);

    //* Handle Resize and Scroll Event Listener 
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 500) {
                setShownav(false)
            }
        };

        const handleScroll = () => {
            if (window.scrollY > 20) {
                dispatch(CommonActions.setScreenScroll(true));
            } else {
                dispatch(CommonActions.setScreenScroll(false));
            }
        }

        const handleClickOutside = (event) => {
            if (navRef.current && !navRef.current.contains(event.target)) {
                setShownav(false);
            }
        };

        window.addEventListener('resize', handleResize);
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('scroll', handleScroll);

        if (shownav) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            window.removeEventListener('resize', handleResize);
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('scroll', handleScroll);
        };
    }, [shownav, isScreenScroll]);

    useEffect(() => {
        customerDetails && dispatch(EcommerceActions?.getProductCart());
    }, [customerDetails]);

    return (
        <>
            <ComingSoonModal isOpen={showComingSoon} onClose={() => setShowComingSoon(false)} />
            <header className={`fixed w-full z-50 top-0 px-4 py-3 bg-white shadow-md`} style={{ marginLeft: isDashboardRoute ? sidebarWidth : '' }}>
                <main className='flex items-center justify-between'>
                    <Link to={'/'}><img src={Logo} className='h-10 lg:h-12' /></Link>

                    <nav className='max-md:hidden flex max-md:flex-wrap items-center gap-1 text-[15px] font-medium'>
                        <NavLink to={'/'} className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "bg-primary text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out" : "hover:bg-primary hover:text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out"}>Home</NavLink>
                        {/* <NavLink to={'/flights-booking'} className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "bg-primary text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out" : "hover:bg-primary hover:text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out"}>Flights</NavLink> */}
                        <button onClick={() => setShowComingSoon(true)} className="hover:bg-primary hover:text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out">Recharge</button>
                        <NavLink to={'/milan-sathi'} className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "bg-primary text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out" : "hover:bg-primary hover:text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out"}>Milan Sathi</NavLink>
                        <NavLink to={'/puja'} className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "bg-primary text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out" : "hover:bg-primary hover:text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out"}>Book a Puja</NavLink>
                        <NavLink to={'/marketplace'} className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "bg-primary text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out" : "hover:bg-primary hover:text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out"}>Marketplace</NavLink>
                        <NavLink to={'/new-yatra'} className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "bg-primary text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out" : "hover:bg-primary hover:text-white px-5 py-1 rounded-lg  transition-all duration-200 ease-out"}>Yatra</NavLink>
                    </nav>

                    <div className='flex gap-5'>
                        {!customerDetails &&
                            <div
                                onClick={() => dispatch(AuthActions.toggleLoginModal(true))}
                                className='bg-gradient-to-r from-[#4EADFD] to-primary text-xs px-2 py-1 lg:py-1.5 flex items-center justify-between gap-3 rounded-md text-white cursor-pointer'>
                                <div className='flex items-center gap-1'>
                                    <div><img src={LogoCircle} className='h-7 w-7' /></div>
                                    <div>Login to Milan Sathi</div>
                                </div>
                                <div className='inline-block rotate-90'><ArrowHeadSvg h={20} w={20} /></div>
                            </div>
                        }

                        {customerDetails && Object.keys(customerDetails).length > 0 && <>
                            <Link to={`/cart/products-cart`} className='flex items-center gap-1 cursor-pointer text-secondary font-semibold'>
                                <div className='flex relative'>
                                    <ShoppingCart />
                                    <p className='absolute -right-1 -top-3'>{productCartData?.data?.reduce((acc, value) => acc + value?.quantity || 0, 0)}</p>
                                </div>
                            </Link>
                        </>}

                        {customerDetails && Object.keys(customerDetails).length > 0 && <>
                            <Link to={`/dashboard`} className='flex items-center gap-1 cursor-pointer text-secondary font-semibold'><PersonSvg /> <div>{customerDetails?.firstname || customerDetails?.mobile}</div></Link>
                        </>}
                    </div>
                </main>
            </header>
        </>
    )
}

export default MilanSathiHeader;